import { render, staticRenderFns } from "./PatientTC.vue?vue&type=template&id=3c8def45&"
import script from "./PatientTC.vue?vue&type=script&lang=js&"
export * from "./PatientTC.vue?vue&type=script&lang=js&"
import style0 from "./PatientTC.vue?vue&type=style&index=0&id=3c8def45&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports